import { lazy as lazyLoad } from 'react';

import type { RouteDefinition } from '../../route';
import { route } from '../job-list/constants';

const lazy = {
    JobPage: lazyLoad(async () => {
        const { JobPage } = await import('./JobDetails');

        return { default: JobPage };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.jobs.title',
        page: lazy.JobPage,
        path: route.patterns.job.details,
    },
];
